import React, { useState, useEffect, useRef } from "react";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import OfferSection from "./OfferSection";
import RestaurantOfferSection from "./RestaurantOfferSection";
import ItemSection from "./ItemSection";
import RestaurantSection from "./RestaurantSection";
import { showMessage } from "../../Functionalities/Functions";
import { ManageSection } from "../Sections/Logic";
import { is_superuser, protocol } from "../../Functionalities/Config";
import AdsSection from "./AdsSection";
import { confirmAlert } from "react-confirm-alert";
import LoadingComponent from "../../CoreComponents/LoadingComponent";
import NoImage from "../../Assets/images/no-image.png";
import "./sections.css";

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const getItemStyle = (draggableStyle, isDragging) => ({
  userSelect: "none",
  margin: "0 0 12px 0",
  color: "black",
  border: isDragging ? "2px solid #EF4832" : "1px solid #eef2f6",
  borderRadius: "14px",
  background: "#ffffff",
  boxShadow: isDragging
    ? "0 16px 32px rgba(239, 72, 50, 0.22), 0 4px 12px rgba(0,0,0,0.08)"
    : "0 2px 6px rgba(0, 0, 0, 0.03)",
  transition: isDragging ? "none" : "border-color 0.2s, box-shadow 0.2s",
  overflow: "hidden",
  ...draggableStyle,
});

const getListStyle = (isDraggingOver) => ({
  padding: "4px 0",
  minHeight: "350px",
});

// Droppable wrapper for React 18 StrictMode compatibility
const StrictModeDroppable = ({ children, ...props }) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true));
    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);

  if (!enabled) {
    return null;
  }

  return <Droppable {...props}>{children}</Droppable>;
};

function Body() {
  const [Items, setItems] = useState([]);
  const [item_ids, setItem_ids] = useState([]);
  const [data, setData] = useState({ id: "", name: "", data: [] });
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(true);

  // Studio UX states
  const [searchTerm, setSearchTerm] = useState("");
  const [typeFilter, setTypeFilter] = useState("ALL");
  const [viewMode, setViewMode] = useState("split"); // 'split' | 'phone'
  const [activeHighlight, setActiveHighlight] = useState(null);
  const [currentTime, setCurrentTime] = useState("9:41");
  const viewportRef = useRef(null);

  // Phone status bar time
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      let hours = now.getHours();
      const minutes = now.getMinutes().toString().padStart(2, "0");
      setCurrentTime(`${hours}:${minutes}`);
    };
    updateTime();
    const timer = setInterval(updateTime, 30000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    getData();
  }, [reload]);

  const refreshData = () => {
    setLoading(true);
    getData();
  };

  function remove(id, keyword, data) {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div
            className="custom-ui"
            style={{
              borderRadius: 8,
              border: "solid",
              padding: 70,
              borderWidth: 0.5,
            }}
          >
            <h1>Are you sure?</h1>
            <p>You want to delete ?</p>
            <button
              onClick={onClose}
              className="btn btn-primary"
              style={{ marginRight: 10 }}
            >
              Cancel
            </button>
            <button
              onClick={() => {
                onClose();
                let res = ManageSection(
                  "",
                  { id: data.id, offer_id: id },
                  keyword,
                  ""
                );
                res
                  .then((res) => {
                    if (res) {
                      showMessage(
                        "Delete success",
                        "success",
                        "Success!",
                        "top",
                        "top-right"
                      );
                      getData();
                    } else {
                      showMessage(
                        "delete failed",
                        "danger",
                        "Failed!",
                        "top",
                        "top-right"
                      );
                    }
                  })
                  .catch((err) => {
                    showMessage(
                      res?.data?.Error || "Error occurred",
                      "danger",
                      "Error!",
                      "top",
                      "top-right"
                    );
                  });
              }}
              className="btn btn-primary"
            >
              Delete
            </button>
          </div>
        );
      },
    });
  }

  const getData = async () => {
    let params = "page_wise=false";
    let result = ManageSection("", "", "get", params);
    result
      .then(async (result) => {
        setData({
          ...data,
          data: result.data,
        });
        let new_list = [];
        (await result.data.length) > 0 &&
          result.data.map((item, index) =>
            new_list.push({
              id: String(item.id).replace(/"/g, ""),
              rawItem: item,
              index: String(index),
              sections:
                item.section_type === "REGULAR" ? (
                  item.object_type === "BRANCH" ? (
                    <RestaurantSection
                      data={item}
                      refreshData={refreshData}
                      remove={remove}
                    />
                  ) : (
                    <RestaurantSection
                      data={item}
                      refreshData={refreshData}
                      priority={item.priority}
                    />
                  )
                ) : item.section_type === "OFFER" ? (
                  <OfferSection
                    image_type={item.image_type}
                    refreshData={refreshData}
                    data={item}
                    priority={item.priority}
                    remove={remove}
                  />
                ) : (
                  <AdsSection data={item} refreshData={refreshData} />
                ),
            })
          );
        setItems(new_list);
        setLoading(false);
      })
      .catch((err) => {
        showMessage(
          "Loading failed",
          "danger",
          "Loading error",
          "top",
          "top-right",
          0
        );
        setLoading(false);
      });
  };

  const reorderItems = (order_list) => {
    let result = ManageSection("", { order_list: order_list }, "patch", "");
    if (!result || typeof result.then !== "function") return;
    result
      .then((res) => {
        if (res && res.data && (res.data.Status || res.data.status)) {
          showMessage(
            "Reorder Success",
            "success",
            "Success!",
            "top",
            "top-right",
            0
          );
        } else if (res && res.data && (res.data.Error || res.data.message)) {
          showMessage(
            res.data.Error || res.data.message,
            "danger",
            "Reorder Failed",
            "top",
            "top-right",
            0
          );
        } else if (res && res.status === 200) {
          showMessage(
            "Reorder Success",
            "success",
            "Success!",
            "top",
            "top-right",
            0
          );
        } else {
          showMessage(
            "Reorder Failed",
            "danger",
            "Failed!",
            "top",
            "top-right",
            0
          );
        }
      })
      .catch((err) => {
        showMessage(
          err?.response?.data?.Error || err?.message || "Reorder Failed",
          "danger",
          "Failed!",
          "top",
          "top-right",
          0
        );
      });
  };

  const handleUnifiedDragEnd = async (result) => {
    if (!result.destination) {
      return;
    }

    if (result.source.droppableId !== result.destination.droppableId) {
      return;
    }

    if (result.source.droppableId === "outline-feed-droppable") {
      onOutlineDragEnd(result);
    } else if (result.source.droppableId === "phone-feed-droppable") {
      onPhoneDragEnd(result);
    }
  };

  const onPhoneDragEnd = async (result) => {
    if (!result.destination) {
      return;
    }

    if (result.source.index === result.destination.index) {
      return;
    }

    const newItems = reorder(
      Items,
      result.source.index,
      result.destination.index
    );

    setItems(newItems);

    let item_ids = newItems.map((item) => {
      if (item.rawItem && item.rawItem.id != null) {
        return item.rawItem.id;
      }
      return Number(item.id) || item.id;
    });
    reorderItems(item_ids);
  };

  const onOutlineDragEnd = async (result) => {
    if (!result.destination) {
      return;
    }

    if (result.source.index === result.destination.index) {
      return;
    }

    const sourceItem = filteredOutlineItems[result.source.index];
    const destItem = filteredOutlineItems[result.destination.index];

    if (!sourceItem || !destItem) {
      return;
    }

    const sourceMasterIndex = Items.findIndex(
      (it) => String(it.id) === String(sourceItem.id)
    );
    const destMasterIndex = Items.findIndex(
      (it) => String(it.id) === String(destItem.id)
    );

    if (sourceMasterIndex === -1 || destMasterIndex === -1) {
      return;
    }

    const newItems = reorder(Items, sourceMasterIndex, destMasterIndex);
    setItems(newItems);

    let item_ids = newItems.map((item) => {
      if (item.rawItem && item.rawItem.id != null) {
        return item.rawItem.id;
      }
      return Number(item.id) || item.id;
    });
    reorderItems(item_ids);
    scrollToSectionInPhone(sourceItem.id);
  };

  // Reordering via Move Up / Move Down buttons from left outline
  const moveSection = (masterIndex, direction) => {
    const targetIndex = direction === "up" ? masterIndex - 1 : masterIndex + 1;
    if (targetIndex < 0 || targetIndex >= Items.length) return;
    const newItems = [...Items];
    const [moved] = newItems.splice(masterIndex, 1);
    newItems.splice(targetIndex, 0, moved);
    setItems(newItems);

    let item_ids = newItems.map((item) => {
      if (item.rawItem && item.rawItem.id != null) {
        return item.rawItem.id;
      }
      return Number(item.id) || item.id;
    });
    reorderItems(item_ids);
    scrollToSectionInPhone(moved.id);
  };

  // Jump and highlight a section in the phone frame preview
  const scrollToSectionInPhone = (itemId) => {
    setActiveHighlight(itemId);
    const element = document.getElementById(`phone-section-${itemId}`);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    setTimeout(() => {
      setActiveHighlight(null);
    }, 2000);
  };

  const scrollToTop = () => {
    if (viewportRef.current) {
      viewportRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  // Filtered outline items for the left management panel
  const filteredOutlineItems = Items.filter((item) => {
    const raw = item.rawItem || {};
    const matchesSearch =
      !searchTerm ||
      (raw.name || "").toLowerCase().includes(searchTerm.toLowerCase());
    const matchesType =
      typeFilter === "ALL" ||
      (raw.section_type || "").toUpperCase() === typeFilter;
    return matchesSearch && matchesType;
  });

  // Statistics
  const totalSections = Items.length;
  const activeSectionsCount = Items.filter((it) => it.rawItem?.is_active).length;
  const offerSectionsCount = Items.filter(
    (it) => it.rawItem?.section_type === "OFFER"
  ).length;
  const restaurantSectionsCount = Items.filter(
    (it) => it.rawItem?.section_type === "REGULAR"
  ).length;
  const adsSectionsCount = Items.filter(
    (it) => it.rawItem?.section_type === "ADS"
  ).length;

  return (
    <>
      {!is_superuser && (
        <div className="content-body">
          <div className="container-fluid py-4">
            {loading ? (
              <LoadingComponent />
            ) : (
              <>
                {/* Studio Header Bar */}
                <div className="studio-header-card">
                  <div className="d-flex flex-wrap align-items-center justify-content-between">
                    <div className="mb-3 mb-md-0">
                      <span className="studio-pill-badge">
                        <i className="fa fa-mobile"></i> Mobile Feed Studio
                      </span>
                      <h2 className="studio-title">Mobile Landing Page Configurator</h2>
                      <p className="studio-subtitle">
                        Manage, reorder, and preview real-time customer app home feed sections.
                      </p>
                    </div>

                    <div className="d-flex flex-wrap align-items-center gap-2">
                      {/* View Mode Toggle */}
                      <div className="btn-group mr-2 mb-2 mb-sm-0" role="group">
                        <button
                          type="button"
                          className={`btn btn-sm ${
                            viewMode === "split" ? "btn-primary" : "btn-outline-primary"
                          }`}
                          onClick={() => setViewMode("split")}
                          title="Split Studio (Workspace + Phone Preview)"
                        >
                          <i className="fa fa-columns mr-1"></i> Split View
                        </button>
                        <button
                          type="button"
                          className={`btn btn-sm ${
                            viewMode === "phone" ? "btn-primary" : "btn-outline-primary"
                          }`}
                          onClick={() => setViewMode("phone")}
                          title="Phone Only Focus"
                        >
                          <i className="fa fa-mobile mr-1"></i> Phone Focus
                        </button>
                      </div>

                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary mr-2 mb-2 mb-sm-0"
                        onClick={refreshData}
                        title="Reload feed data"
                      >
                        <i className="fa fa-refresh mr-1"></i> Refresh
                      </button>

                      <a
                        href="/sections"
                        className="btn btn-sm btn-outline-primary mr-2 mb-2 mb-sm-0"
                      >
                        <i className="fa fa-list mr-1"></i> All Sections
                      </a>

                      <a
                        href="/add-section"
                        className="btn btn-sm btn-primary mb-2 mb-sm-0"
                        style={{ background: "#EF4832", borderColor: "#EF4832" }}
                      >
                        <i className="fa fa-plus mr-1"></i> Add Section
                      </a>
                    </div>
                  </div>
                </div>

                {/* Studio Stats Summary */}
                <div className="row mb-4">
                  <div className="col-xl-3 col-sm-6 mb-3 mb-xl-0">
                    <div className="studio-stat-card">
                      <div>
                        <div className="studio-stat-num">{totalSections}</div>
                        <div className="studio-stat-label">Total Feed Sections</div>
                      </div>
                      <div className="studio-stat-icon stat-icon-orange">
                        <i className="fa fa-th-large"></i>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-3 col-sm-6 mb-3 mb-xl-0">
                    <div className="studio-stat-card">
                      <div>
                        <div className="studio-stat-num text-success">{activeSectionsCount}</div>
                        <div className="studio-stat-label">Active in Customer App</div>
                      </div>
                      <div className="studio-stat-icon stat-icon-green">
                        <i className="fa fa-check-circle-o"></i>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-3 col-sm-6 mb-3 mb-xl-0">
                    <div className="studio-stat-card">
                      <div>
                        <div className="studio-stat-num" style={{ color: "#7c3aed" }}>
                          {offerSectionsCount}
                        </div>
                        <div className="studio-stat-label">Offer & Banner Sliders</div>
                      </div>
                      <div className="studio-stat-icon stat-icon-purple">
                        <i className="fa fa-tags"></i>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-3 col-sm-6">
                    <div className="studio-stat-card">
                      <div>
                        <div className="studio-stat-num" style={{ color: "#3b82f6" }}>
                          {restaurantSectionsCount}
                        </div>
                        <div className="studio-stat-label">Restaurant Lists</div>
                      </div>
                      <div className="studio-stat-icon stat-icon-blue">
                        <i className="fa fa-cutlery"></i>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Main Content Workspace */}
                <DragDropContext onDragEnd={handleUnifiedDragEnd}>
                  <div className="row">
                    {/* Left Column: Sections Outline & Manager (Visible in split mode) */}
                    {viewMode === "split" && (
                      <div className="col-xl-6 col-lg-6 mb-4">
                        <div className="sections-outline-card">
                          <div className="sections-outline-header">
                            <div>
                              <h5 className="mb-0 font-weight-bold text-dark">
                                App Feed Structure
                              </h5>
                              <small className="text-muted">
                                Drag rows or use arrows to adjust feed order
                              </small>
                            </div>

                            <div className="outline-search-box">
                              <i className="fa fa-search search-icon"></i>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Search section..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                              />
                            </div>
                          </div>

                          {/* Filter Tabs */}
                          <div className="px-3 pt-2 pb-1 border-bottom bg-light d-flex align-items-center gap-1 flex-wrap">
                            <button
                              type="button"
                              className={`btn btn-xs ${
                                typeFilter === "ALL" ? "btn-dark" : "btn-light"
                              } mr-1 mb-1`}
                              onClick={() => setTypeFilter("ALL")}
                            >
                              All ({totalSections})
                            </button>
                            <button
                              type="button"
                              className={`btn btn-xs ${
                                typeFilter === "OFFER" ? "btn-dark" : "btn-light"
                              } mr-1 mb-1`}
                              onClick={() => setTypeFilter("OFFER")}
                            >
                              Offers ({offerSectionsCount})
                            </button>
                            <button
                              type="button"
                              className={`btn btn-xs ${
                                typeFilter === "REGULAR" ? "btn-dark" : "btn-light"
                              } mr-1 mb-1`}
                              onClick={() => setTypeFilter("REGULAR")}
                            >
                              Restaurants ({restaurantSectionsCount})
                            </button>
                            {adsSectionsCount > 0 && (
                              <button
                                type="button"
                                className={`btn btn-xs ${
                                  typeFilter === "ADS" ? "btn-dark" : "btn-light"
                                } mb-1`}
                                onClick={() => setTypeFilter("ADS")}
                              >
                                Ads ({adsSectionsCount})
                              </button>
                            )}
                          </div>

                          {/* Drag and Drop Outline List on Left Panel */}
                          <StrictModeDroppable droppableId="outline-feed-droppable">
                            {(provided, snapshot) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                                className="sections-outline-list"
                                style={{
                                  background: snapshot.isDraggingOver
                                    ? "rgba(239, 72, 50, 0.03)"
                                    : "transparent",
                                  minHeight: "160px",
                                }}
                              >
                                {filteredOutlineItems.length > 0 ? (
                                  filteredOutlineItems.map((item, listIndex) => {
                                    const raw = item.rawItem || {};
                                    const masterIndex = Items.findIndex(
                                      (it) => String(it.id) === String(item.id)
                                    );
                                    const displayIndex =
                                      masterIndex !== -1 ? masterIndex : listIndex;
                                    const isFirst = displayIndex === 0;
                                    const isLast =
                                      displayIndex === Items.length - 1;
                                    const iconSrc = raw.icon
                                      ? raw.icon.image
                                        ? raw.icon.image
                                        : NoImage
                                      : NoImage;
                                    const itemCount =
                                      raw.section_type === "OFFER"
                                        ? raw.offer?.length || 0
                                        : raw.is_branch?.length || 0;

                                    return (
                                      <Draggable
                                        key={`outline-${item.id}`}
                                        draggableId={`outline-${item.id}`}
                                        index={listIndex}
                                        isDragDisabled={Boolean(searchTerm)}
                                      >
                                        {(provided, snapshot) => (
                                          <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            className={`section-outline-row ${
                                              snapshot.isDragging
                                                ? "outline-row-dragging"
                                                : ""
                                            }`}
                                            style={{
                                              ...provided.draggableProps.style,
                                            }}
                                          >
                                            <div className="outline-row-left">
                                              {/* Dedicated Drag Handle Icon */}
                                              <div
                                                className="outline-drag-handle"
                                                title="Hold & drag to reorder section"
                                              >
                                                <svg
                                                  width="14"
                                                  height="18"
                                                  viewBox="0 0 14 18"
                                                  fill="currentColor"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  className="drag-handle-svg"
                                                >
                                                  <circle cx="4" cy="3" r="1.5" />
                                                  <circle cx="10" cy="3" r="1.5" />
                                                  <circle cx="4" cy="9" r="1.5" />
                                                  <circle cx="10" cy="9" r="1.5" />
                                                  <circle cx="4" cy="15" r="1.5" />
                                                  <circle cx="10" cy="15" r="1.5" />
                                                </svg>
                                              </div>

                                              <div className="outline-index-badge">
                                                #{displayIndex + 1}
                                              </div>

                                              <img
                                                src={iconSrc}
                                                alt=""
                                                className="outline-section-thumb"
                                                onError={(e) => {
                                                  e.target.onerror = null;
                                                  e.target.src = NoImage;
                                                }}
                                              />

                                              <div className="outline-section-info">
                                                <div className="outline-section-title">
                                                  {raw.name || `Section ${displayIndex + 1}`}
                                                </div>
                                                <div className="d-flex align-items-center gap-1">
                                                  {raw.section_type === "OFFER" ? (
                                                    <span className="outline-badge-pill badge-offer">
                                                      Offers • {itemCount} banners
                                                    </span>
                                                  ) : raw.section_type === "REGULAR" ? (
                                                    <span className="outline-badge-pill badge-restaurant">
                                                      Restaurants • {itemCount} items
                                                    </span>
                                                  ) : (
                                                    <span className="outline-badge-pill badge-ads">
                                                      Ad Banner
                                                    </span>
                                                  )}
                                                  {raw.is_active ? (
                                                    <span
                                                      className="badge badge-xs badge-success ml-1"
                                                      style={{ fontSize: "10px" }}
                                                    >
                                                      Active
                                                    </span>
                                                  ) : (
                                                    <span
                                                      className="badge badge-xs badge-light text-muted ml-1"
                                                      style={{ fontSize: "10px" }}
                                                    >
                                                      Inactive
                                                    </span>
                                                  )}
                                                </div>
                                              </div>
                                            </div>

                                            <div
                                              className="outline-row-actions"
                                              onMouseDown={(e) => e.stopPropagation()}
                                              onTouchStart={(e) => e.stopPropagation()}
                                            >
                                              <button
                                                type="button"
                                                className="btn-outline-action"
                                                disabled={isFirst}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  moveSection(displayIndex, "up");
                                                }}
                                                title="Move Up"
                                              >
                                                <i className="fa fa-arrow-up"></i>
                                              </button>
                                              <button
                                                type="button"
                                                className="btn-outline-action"
                                                disabled={isLast}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  moveSection(displayIndex, "down");
                                                }}
                                                title="Move Down"
                                              >
                                                <i className="fa fa-arrow-down"></i>
                                              </button>
                                              <button
                                                type="button"
                                                className="btn-outline-action btn-action-highlight"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  scrollToSectionInPhone(item.id);
                                                }}
                                                title="Scroll to section in phone preview"
                                              >
                                                <i className="fa fa-eye"></i>
                                              </button>
                                              <a
                                                href={`/section/${raw.id}`}
                                                className="btn-outline-action"
                                                title="Edit Section Details"
                                                onClick={(e) => e.stopPropagation()}
                                              >
                                                <i className="fa fa-pencil"></i>
                                              </a>
                                            </div>
                                          </div>
                                        )}
                                      </Draggable>
                                    );
                                  })
                                ) : (
                                  <div className="text-center py-5 text-muted">
                                    <i className="fa fa-inbox fa-3x mb-2 text-light"></i>
                                    <p className="mb-0">No sections found matching your filter.</p>
                                  </div>
                                )}
                                {provided.placeholder}
                              </div>
                            )}
                          </StrictModeDroppable>

                        {/* Guidance Footer */}
                        <div className="p-3 bg-light border-top">
                          <div className="d-flex align-items-center text-muted" style={{ fontSize: "12px" }}>
                            <i className="fa fa-info-circle text-primary mr-2" style={{ fontSize: "14px" }}></i>
                            <span>
                              <strong>Pro Tip:</strong> Drag sections directly in this list OR inside the phone preview. Changes automatically update the live customer app.
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Right Column: Interactive Mobile Phone Stage */}
                  <div className={viewMode === "split" ? "col-xl-6 col-lg-6 mb-4" : "col-xl-8 col-lg-10 mx-auto mb-4"}>
                    <div className="mobile-studio-stage">
                      {/* Stage Top Bar */}
                      <div className="stage-top-bar">
                        <div className="stage-device-name">
                          <span className="live-pulse-dot"></span>
                          <span>Apple iPhone 16 Pro Max Preview</span>
                        </div>
                        <div className="d-flex align-items-center">
                          <button
                            type="button"
                            className="btn btn-xs btn-outline-secondary"
                            onClick={scrollToTop}
                            title="Scroll preview to top"
                          >
                            <i className="fa fa-arrow-up mr-1"></i> Top
                          </button>
                        </div>
                      </div>

                      {/* THE PROPER MOBILE PHONE FRAME */}
                      <div className="mobile-phone-device">
                        {/* Hardware Side Buttons */}
                        <div className="phone-hw-btn phone-btn-mute"></div>
                        <div className="phone-hw-btn phone-btn-vol-up"></div>
                        <div className="phone-hw-btn phone-btn-vol-down"></div>
                        <div className="phone-hw-btn phone-btn-power"></div>

                        {/* Phone Screen Inner Container */}
                        <div className="phone-screen-inner">
                          {/* Top Status Bar */}
                          <div className="phone-status-bar">
                            <span className="phone-time">{currentTime}</span>

                            {/* Dynamic Island Notch */}
                            <div className="phone-dynamic-island">
                              <div className="phone-island-camera"></div>
                              <div className="phone-island-sensor"></div>
                            </div>

                            {/* Status Bar Icons */}
                            <div className="phone-status-icons">
                              <div className="phone-cellular-bars">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                              </div>
                              <i className="fa fa-wifi" style={{ fontSize: "11px" }}></i>
                              <div className="phone-battery-icon">
                                <div className="phone-battery-level"></div>
                              </div>
                            </div>
                          </div>

                          {/* App Top Header Bar */}
                          <div className="phone-app-header">
                            <div className="d-flex align-items-center justify-content-between">
                              <div>
                                <div className="phone-delivery-loc-label">DELIVER TO</div>
                                <div className="phone-delivery-loc-addr">
                                  <i className="fa fa-map-marker text-danger mr-1"></i>
                                  <span>Home, Downtown ▾</span>
                                </div>
                              </div>
                              <div className="d-flex align-items-center gap-2">
                                <div
                                  className="rounded-circle bg-light d-flex align-items-center justify-content-center mr-1"
                                  style={{ width: "28px", height: "28px", color: "#475569" }}
                                >
                                  <i className="fa fa-bell-o" style={{ fontSize: "12px" }}></i>
                                </div>
                                <div
                                  className="rounded-circle bg-light d-flex align-items-center justify-content-center"
                                  style={{ width: "28px", height: "28px", color: "#475569" }}
                                >
                                  <i className="fa fa-shopping-basket" style={{ fontSize: "12px" }}></i>
                                </div>
                              </div>
                            </div>

                            <div className="phone-app-search">
                              <i className="fa fa-search mr-2"></i>
                              <span>Search restaurants, dishes...</span>
                            </div>
                          </div>

                          {/* Scrollable Viewport (Drag & Drop Sections) */}
                          <div className="phone-screen-viewport" ref={viewportRef}>
                            <StrictModeDroppable droppableId="phone-feed-droppable">
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  style={getListStyle(snapshot.isDraggingOver)}
                                  {...provided.droppableProps}
                                >
                                  {Items.map((item, index) => {
                                    return (
                                      <Draggable
                                        key={`phone-${item.id}`}
                                        draggableId={`phone-${item.id}`}
                                        index={index}
                                      >
                                        {(provided, snapshot) => (
                                          <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            id={`phone-section-${item.id}`}
                                            className={`phone-section-container ${
                                              activeHighlight === item.id
                                                ? "section-pulse-highlight"
                                                : ""
                                            }`}
                                            style={getItemStyle(
                                              provided.draggableProps.style,
                                              snapshot.isDragging
                                            )}
                                          >
                                            {/* Card Drag Grip */}
                                            <div
                                              className="phone-card-drag-grip"
                                              title="Hold & drag to reorder section"
                                            >
                                              <span className="drag-section-order-badge">
                                                #{index + 1}
                                              </span>
                                              <span className="drag-grip-indicator"></span>
                                              <span style={{ fontSize: "10px", color: "#94a3b8" }}>
                                                <i className="fa fa-arrows-v"></i>
                                              </span>
                                            </div>

                                            <div className="p-2">
                                              {item.sections}
                                            </div>
                                          </div>
                                        )}
                                      </Draggable>
                                    );
                                  })}
                                  {provided.placeholder}
                                </div>
                              )}
                            </StrictModeDroppable>
                          </div>

                          {/* App Bottom Tab Navigation */}
                          <div className="phone-app-bottom-nav">
                            <div className="phone-nav-item active">
                              <i className="fa fa-home"></i>
                              <span>Home</span>
                            </div>
                            <div className="phone-nav-item">
                              <i className="fa fa-search"></i>
                              <span>Explore</span>
                            </div>
                            <div className="phone-nav-item">
                              <i className="fa fa-cutlery"></i>
                              <span>Orders</span>
                            </div>
                            <div className="phone-nav-item">
                              <i className="fa fa-user-o"></i>
                              <span>Account</span>
                            </div>
                          </div>

                          {/* iOS Bottom Home Indicator */}
                          <div className="phone-home-indicator-bar">
                            <div className="phone-home-pill"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </DragDropContext>
            </>
          )}
          </div>
        </div>
      )}
    </>
  );
}

function mobileLandingPage() {
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={"Mobile Landing Page Studio"} subHeading={"Mobile App Feed Management"} />
        <NavBar />
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default mobileLandingPage;

